import { Label } from 'semantic-ui-react';
import React from 'react';
import cn from 'classnames';
import { string, node } from 'prop-types';
import { Field } from 'formik';
import InputMask from 'react-input-mask';

const FieldWithValidity = ({
  className,
  label,
  error,
  qa,
  mask,
  maskChar = '',
  ...rest
}) => {
  const fieldCSS = cn('field', className, error && 'error');
  // querySelector does not work with dots(.) - for e2e
  const id = rest.name && rest.name.replace('.', '_');
  const { onChange, ...maskRest } = rest;

  return (
    <div className={fieldCSS}>
      <label htmlFor={id}>{label}</label>
      {mask ? (
        <InputMask
          mask={mask}
          maskChar={maskChar}
          onChange={onChange}
          {...maskRest}
        >
          {inputProps => (
            <Field data-qa={qa} id={id} {...maskRest} {...inputProps} />
          )}
        </InputMask>
      ) : (
        <Field data-qa={qa} id={id} {...rest} />
      )}

      {error && (
        <Label basic pointing color="red">
          {error}
        </Label>
      )}
    </div>
  );
};

FieldWithValidity.propTypes = {
  className: string,
  error: node,
  label: node,
  mask: string,
  maskChar: string
};
export default FieldWithValidity;
